export const gumHealthAnalysis = ({ tpscore, user_info, riskactorsList }) => {
    const analysisCard = [
        "healthy gums",
        "at risk of gingivitis",
        "gingivitis",
        "advanced gum disease",
    ]

    const tpscoreObj = tpscore || {}
    const questionnaire = user_info || {}

    if (!riskactorsList || riskactorsList.length < 6) {
        console.warn('Missing required data for gum health analysis, defaulting to healthy gums:', { tpscore, user_info, riskactorsList });
        return {
            final_result: analysisCard[0],
            final_risk_factor: riskactorsList?.[5] || "No risk factors"
        }
    }

    const { tartar_score = 0, gum_swelling = 0, gum_recession = 0 } = tpscoreObj

    const getBoolean = (string) => string === "yes"

    const smoking = getBoolean(questionnaire["Do you smoke?"])
    const pregnant = getBoolean(questionnaire["Are you pregnant or just delivered a baby?"])
    const diabetes = getBoolean(questionnaire["Do you suffer from diabetes?"])
    const implants = getBoolean(questionnaire["Do you have crowns, braces or implants in your mouth?"])
    const toothLoose = getBoolean(questionnaire["Do any of your teeth feel loose?"])

    const risk_factor = []
    if (smoking) risk_factor.push(riskactorsList[0])
    if (pregnant) risk_factor.push(riskactorsList[1])
    if (diabetes) risk_factor.push(riskactorsList[2])
    if (implants) risk_factor.push(riskactorsList[3])
    if (toothLoose) risk_factor.push(riskactorsList[4])

    // Severity indices: 0=healthy gums, 1=at risk of gingivitis, 2=gingivitis, 3=advanced gum disease
    // escalate() only ever increases severity — implements "highest severity wins"
    let severity = 0
    const escalate = (s) => { if (s > severity) severity = s }

    if (tartar_score === 0 && gum_swelling === 0 && gum_recession === 0) {
        // All scores = 0
        if (toothLoose) {
            escalate(3) // advanced gum disease
        } else if (smoking || pregnant || diabetes || implants) {
            escalate(1) // at risk of gingivitis
        }
        // else: severity stays 0 → healthy gums
    } else {
        // Tartar rules
        if (tartar_score > 0) {
            if (diabetes) escalate(2) // gingivitis
            else escalate(1)          // at risk (no risk / smoking / pregnant / implants)
        }

        // Gum swelling rules
        if (gum_swelling > 0) {
            if (diabetes) escalate(3) // advanced gum disease
            else escalate(2)          // gingivitis (no risk / smoking / pregnant / implants)
        }

        // Gum recession — always advanced gum disease regardless of risk factors
        if (gum_recession > 0) {
            escalate(3)
        }
    }

    const final_result = analysisCard[severity]
    const final_risk_factor = risk_factor.length === 0 ? riskactorsList[5] : risk_factor.join(", ")

    return { final_result, final_risk_factor }
}
